export default __webpack_public_path__ + "static/media/listbg.71a43693.png";